import { ThumbDown, ThumbUp } from "@mui/icons-material";
import { BaseModuleSubtype } from "../../../../../../types/actionModule/subtypes/subtype";
import { EvaluationThumbsSubtypeDataModel } from "../../../../../../types/actionModule/subtypes/evaluationThumbsSubtype";

interface Props {
    subtype: BaseModuleSubtype;
    subtypeData: EvaluationThumbsSubtypeDataModel;
}

export default function EvaluationThumbsSubtypeDetails(props: Props) {
    return <>
        {
            props.subtypeData.answer === "ThumbsUp" && <ThumbUp color="success" />
        }
        {
            props.subtypeData.answer === "ThumbsDown" && <ThumbDown color="error" />
        }
    </>
}